<script setup>
import {reactive} from "vue";

const {isHighlightedStop, size} = defineProps({
    isHighlightedStop: {
        type: Boolean,
        required: false,
    },
    size: {
        type: String,
        required: false,
    }
})

const sizes = reactive({
    r: 10,
    cx: 12,
    cy: 12,
    width: 24,
    height: 24,
})

if (size === 'small') {
    sizes.r = 5
    sizes.cx = 7
    sizes.cy = 7
    sizes.width = 14
    sizes.height = 14
}
</script>

<template>
    <div class="svg-marker-div" :aria-current="isHighlightedStop" :class="{isHighlightedStop, 'small-size': size === 'small'}">
        <svg xmlns="http://www.w3.org/2000/svg" :width="sizes.width" :height="sizes.height">
            <circle
                class="marker-circle"
                stroke='#502059'
                stroke-width="2"
                :r="sizes.r"
                :cx="sizes.cx"
                :cy="sizes.cy"
            />
        </svg>
    </div>
</template>

<style scoped>
.marker-circle {
    fill: #fff;
}
.isHighlightedStop .marker-circle {
    fill: #502059;
}
</style>
